import { Wrench } from "lucide-react";
import ComingSoon from "@/components/ComingSoon";

export default function Tools() {
  return (
    <ComingSoon
      icon={Wrench}
      title="Инструменты"
      note="Учёт инструментов и оборудования."
    />
  );
}
